import React from 'react';
import PropTypes from 'prop-types';

import {
	Container,
	Wrapper,
	Header,
	Body,
	Footer,
} from './styles';

const Modal = ({ header, body, footer }) => {
	return (
		<Container>
			<Wrapper>
				<Header>{ header }</Header>
				<Body>{ body }</Body>
				<Footer>{ footer }</Footer>
			</Wrapper>
		</Container>
	);
}

Modal.propTypes = {
	header: PropTypes.any,
	body: PropTypes.any,
	footer: PropTypes.any,
}

export default Modal
